module.exports = __webpack_public_path__ + "static/media/size2.3fbd0610.svg";